/*
 * Validate-discounts.ts
 * Description: Includes the declaration
 * of the functions for validating a discounts
 */

// Importing variables
import {
    MissingFrom, MissingText, MissingTo,
    TooLongFrom, TooLongText, TooLongTo,
} from '@/ts/variables';

export interface Discount {
    text: string;
    from: string;
    to: string;
}

/**
 * Validating discount data before updating
 *
 * @param {String[]} errors - a list of errors
 * @param {Discount} data - discount data
 */
export function validateDiscount(errors: string[], data: Discount) {
    // Validating text
    if (data.text.length === 0) { errors.push(MissingText); }
    if (data.text.length > 255) { errors.push(TooLongText); }

    // Validating from field
    if (data.from.length === 0) { errors.push(MissingFrom); }
    if (data.from.length > 255) { errors.push(TooLongFrom); }

    // Validating to filed
    if (data.to.length === 0) { errors.push(MissingTo); }
    if (data.to.length > 255) { errors.push(TooLongTo); }
}
